const state = {
    identidyInfo: {
        name: '',
        carNo: '',
        phone: '',
        productName: '',
    }
};

export default state;